import { render, staticRenderFns } from "./SpousalSupport.vue?vue&type=template&id=4cd529a3"
import script from "./SpousalSupport.vue?vue&type=script&lang=ts"
export * from "./SpousalSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports